import Vue from "vue";
// import axios from "axios";
import Router from "vue-router";
import store from "./store";
import Home from "@/pages/authenticated/Dashboard";
import routes from "@/router/routes/index.js";
import { websiteUrl } from "@/config.js";
import Courses from "@/pages/authenticated/Courses";
import { isTrialCompanyAdmin } from "@/utils/onboarding";
import { isOpenWhileLocked, resolveWizardLock } from "@/utils/wizardLock";
import { canBookWebinar, openWebinarBooking } from "@/utils/webinarBooking";
import { onRouteChange } from "@/utils/analytics";

Vue.use(Router);

let router = new Router({
  routes: [
  {
      path: "/",
      name: "Courses",
      component: Courses,
      meta: {
        breadcrumb: [
          {
            text: "Dashboard",
            disabled: true,
            href: "/"
          }
        ],
        public: false,
        admin: false
      }
    },
    {
      // The privacy policy lives on the website, one policy for every
      // product. Old in app links, the Edify one included, are sent there.
      path: "/privacy-policy",
      alias: "/privacy-policy-edify",
      meta: { public: true },
      beforeEnter() {
        window.location.replace(websiteUrl("/privacy-policy"));
      }
    }
  ].concat(routes)
});

let previousRoute = null;

router.beforeEach((to, from, next) => {
  // const authenticated = store.state.user.authenticated
  const authenticated = store.getters.isLoggedIn;

  // IMPROVE Live webinar links (the trial emails' ?next=improve-live, the old
  // /improve-live page address): the booking popup opens over wherever the
  // admin lands. Signed out, they log in first and DirectLogin opens it.
  if (to.path === "/improve-live") {
    if (!authenticated) return next({ path: "/login", query: { next: "improve-live" } });
    if (canBookWebinar(store.getters)) openWebinarBooking();
    return next(from.name ? false : "/");
  }
  if (authenticated && to.query.next === "improve-live" && canBookWebinar(store.getters)) {
    openWebinarBooking();
  }

  const userIsAdmin = store.getters.admin;
  const userIsPartner = store.getters.partner;
  const userIsSuperAdmin = store.getters.superAdmin;
  const userIsTeamManager = store.getters.teamManager;
  const userIsAccountManager = store.getters.accountManager;
  const userIsInvoicingAdmin = store.getters.invoicingAdmin;

  const companyState = store.getters.companyState;

  const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut);
  const isPublic = to.matched.some(record => record.meta.public);
  const onlyAdmin = to.matched.some(record => record.meta.admin);
  const onlySuperAdmin = to.matched.some(record => record.meta.superAdmin);
  const suspendedAccessible = to.matched.some(record => record.meta.suspendedAccessible);
  const onlyTeamManager = to.matched.some(record => record.meta.teamManager);
  const onlyInvoicingAdmin = to.matched.some(record => record.meta.invoicingAdmin);

  if (authenticated) {

    if (companyState == 4 || companyState == 2) {
      if ((userIsAdmin || userIsPartner) && !suspendedAccessible) {
        return next("/admin/finance");
      } else {
        return next();
      }
    } else {
      if(from.path == '/admin/password-reset' || from.path == '/password-reset'){
        return next();
      } else if (onlyLoggedOut) {
        return next("/");
      } else if (onlyAdmin && !userIsAdmin) {
        return next("/");
      } else if (onlySuperAdmin && !userIsSuperAdmin) {
        return next("/");
      } else if (onlyTeamManager && userIsTeamManager) {
        next();
      }
      else if (onlyInvoicingAdmin && userIsInvoicingAdmin) {
        next();
      }
      else {
        // A trial admin goes through the Welcome to IMPROVE wizard first
        // (5 Oct 2026): until it is finished, every page outside the short
        // list in wizardLock.js leads back to it, typed URLs and Back
        // included. The lock is settled from the server's progress once per
        // page load (see wizardLock.js), so this only waits the first time.
        if (isTrialCompanyAdmin(store.getters)) {
          return resolveWizardLock(store.getters).then(locked => {
            if (locked && !isOpenWhileLocked(to.path)) {
              return next("/welcome");
            }
            if (to.path === "/") return next(locked ? "/welcome" : "/admin/users");
            if (from.name) previousRoute = from;
            next();
          });
        }
        if (to.path === '/') {
          if (userIsSuperAdmin) return next('/super-admin/companies');
          if (userIsPartner || userIsAccountManager) return next('/partner/users');
          if (userIsAdmin) return next("/admin/users");
          if (userIsTeamManager) return next('/course-library');
          if (userIsInvoicingAdmin)return next('/invoicing-admin/companies');
          return next('/courses');
        }
        next();
      }
    }



  } else {
    if (!isPublic) {
      return next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  }
  if (from.name) {
      previousRoute = from;
    }
});
// Analytics: a page view on each public page, and nothing once anyone is
// signed in (utils/analytics.js).
router.afterEach((to) => {
  onRouteChange(to, store.getters.isLoggedIn);
});

// Make it accessible globally
Vue.prototype.$getPreviousRoute = () => previousRoute;

export default router;
